import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../utils/hooks/useUser';

const Pricing = () => {
  const navigate = useNavigate();
  const { userId, userEmail, isLoading, error } = useUser();

  if (isLoading) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <p className="text-gray-500 mt-2">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-900">Choose Your Plan</h2>
        <p className="mt-4 text-lg text-gray-600">Select the perfect plan for your needs</p>
      </div>

      {/* Add a fallback message */}
      {!process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY && (
        <div className="text-red-500 text-center">
          Stripe configuration is missing. Please check your environment variables.
        </div>
      )}

      <stripe-pricing-table
        pricing-table-id={process.env.REACT_APP_STRIPE_PRICING_TABLE_ID}
        publishable-key={process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}
        client-reference-id={userId}
        customer-email={userEmail}
      >
      </stripe-pricing-table>

      <div className="mt-8 text-center">
        <button
          onClick={() => navigate(-1)}
          className="text-blue-600 hover:text-blue-800"
        >
          ← Go Back
        </button>
      </div>
    </div>
  );
};

export default Pricing; 